import { put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { getCurrentMediaSource } from '../selectors';
import { getPostStreamIdFromMediaSource } from '../helpers';
export default function*() {
    const mediaSource = yield select(getCurrentMediaSource);
    if (!mediaSource) {
        return;
    }
    const streamId = getPostStreamIdFromMediaSource(mediaSource);
    const isFetching = yield select(selectors.isFetching, streamId);
    if (isFetching) {
        return;
    }
    yield put(withOffset.actions.fetch(streamId));
}
